import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { lazy } from "react";

import RouterLayout from "./Router";
import ProtectedRoute from "./routeWrappers/ProtectedRoute";
import Home from "./routeWrappers/Home";
import ErrorBoundary from "./routeWrappers/ErrorBoundary.jsx";
import Login from "../routes/Login";
import Verify from "../routes/Verify.jsx";
import ResetPassword from "../routes/ResetPassword";
import NotFound from "../routes/NotFound";
import EmptyView from "../routes/EmptyView.jsx";
import ROUTES from "./routes";

const DeploymentManagementView = lazy(() => import("../routes/deployment/deploymentManagement/DeploymentManagementView.jsx"));
const RuntimeConfigManagement = lazy(() => import("../routes/deployment/runTimeConfig/RuntimeConfigManagement"));
const BuildTimeConfigManagement = lazy(() => import("../routes/deployment/buildTimeConfig/BuildTimeConfigManagement"));
const NotificationsView = lazy(() => import("../routes/deployment/notifications/NotificationsView"));
const SyncLogsView = lazy(() => import("../routes/deployment/syncLogs/SyncLogsView"));
const UsersView = lazy(() => import("../routes/user/UsersView"));
const EnvironmentTemplateView = lazy(() => import("../routes/environmentTemplate/EnvironmentTemplateView"));
const AuditTrailView = lazy(() => import("../routes/auditTrail/AuditTrailView"));
const ProductsView = lazy(() => import("../routes/productVersion/ProductsView"));
const DomainsView = lazy(() => import("../routes/domain/DomainsView"));
const SiteMonitoringView = lazy(() => import("../routes/SiteMonitoringView"));
const SettingsComparisonView = lazy(() => import("../components/settings/settingsComparison/SettingsComparisonView"));
const LogsView = lazy(() => import("../routes/log/LogsView"));
const EnvironmentsView = lazy(() => import("../routes/environment/EnvironmentsView"));
const EmailManagementView = lazy(() => import("../routes/emailManagement/EmailManagementView.jsx"));
const DownloadablesView = lazy(() => import("../routes/downloadables/DownloadablesView.jsx"));
const AiPipelinesView = lazy(() => import("../routes/aiPipeline/AiPipelinesView"));
const DomainConfigurationManagement = lazy(() => import("../routes/domain/DomainConfigurationManagement.jsx"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RouterLayout />}>
      <Route path="/auth" element={<Login />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<ErrorBoundary><Home /></ErrorBoundary>}>
          <Route path={`/${ROUTES.DEPLOYMENT_MANAGEMENT}/:id`} element={<DeploymentManagementView />} />
          <Route path={`/${ROUTES.RUNTIME_CONFIG}/:id/:objectSubType?`} element={<RuntimeConfigManagement />} />
          <Route path={`/${ROUTES.BUILD_TIME_CONFIG}/:id/:objectSubType?/:objectSubTypeId?/:objectSubTypeVersion?`} element={<BuildTimeConfigManagement />} />
          <Route path={`/${ROUTES.NOTIFICATIONS}/:id/:objectSubType?/:objectSubTypeId?`} element={<NotificationsView />} />
          <Route path={`/${ROUTES.DOMAIN_CONFIGURATION}/:id/:objectSubType?`} element={<DomainConfigurationManagement />} />
          <Route path={`/${ROUTES.SUPPORT_LOGS}/:id?`} element={<SyncLogsView />} />
          <Route path={`/${ROUTES.SITE_MONITORING}`} element={<SiteMonitoringView />} />
          <Route path={`/${ROUTES.USERS}`} element={<UsersView />} />
          <Route path={`/${ROUTES.AUDIT_TRAIL}`} element={<AuditTrailView />} />
          <Route path={`/${ROUTES.ENVIRONMENTS}`} element={<EnvironmentsView />} />
          <Route path={`/${ROUTES.EMAIL_MANAGEMENT}`} element={<EmailManagementView />} />
          <Route path={`/${ROUTES.DOWNLOADABLES}`} element={<DownloadablesView />} />

          {/* Root domain */}          
          <Route path={`/${ROUTES.AI_PIPELINES}`} element={<AiPipelinesView />} />
          <Route path={`/${ROUTES.PRODUCTS}`} element={<ProductsView />} />
          <Route path={`/${ROUTES.DOMAIN_LOGS}`} element={<LogsView />} />
          <Route path={`/${ROUTES.ENVIRONMENT_TEMPLATES}`} element={<EnvironmentTemplateView />} />
          <Route path={`/${ROUTES.SETTINGS_COMPARISON}`} element={<SettingsComparisonView />} />
          <Route path={`/${ROUTES.DOMAINS}`} element={<DomainsView />} />

          <Route index element={<EmptyView />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>
  )
);

export default router;
